import CaseAssetDetails from './CaseAssetDetails';

export default CaseAssetDetails;
